import * as Yup from 'yup';
import { Quotation } from '../../../../../../shared/types/modules/quotation';

export const initialValues: Quotation = {
    callId: '',
    typeQuotation: '',
    typification: '',
    subtypification: '',
    bouquet: '',
    template: '',
    body: '',
};

export const validationSchema = (subtypification: boolean) => {
    const schema: any = {
        callId: Yup.string().max(
            100,
            'El call ID debe tener 100 caracteres alfanuméricos como máximo'
        ),
        bouquet: Yup.string().required('El ramo es obligatorio'),
        typification: Yup.string().required('La tipificación  es obligatoria'),
    };

    if (subtypification)
        schema.subtypification = Yup.string().required(
            'La subtipificación  es obligatoria'
        );

    return Yup.object(schema);
};
